module.exports = __webpack_public_path__ + "static/img/NewsBackground.e07fc6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-v2/NewsBackground.png
// module id = Eadw
// module chunks = 44